"use strict";

exports.__esModule = true;
exports.PlantStateSelector = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _Selector = require("../../Core/Selector");
var _Translator = require("../../Core/Translator");
var _getPlantStateColor = require("../getPlantStateColor");
var _excluded = ["theme", "translator"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function getKey(input) {
  return input.id;
}
function renderItemText(input) {
  return input.name;
}

/**
 * Allows a user to select plant state(s) from a list.
 */

// TODO: Ignoring flow because withTranslator requires theme to be in props
var PlantStateSelector = exports.PlantStateSelector = (0, _Translator.withTranslator)((0, _styledComponents.withTheme)(function (_ref) {
  var theme = _ref.theme,
    translate = _ref.translator.translate,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Selector.Selector, _extends({
    placeholder: props.multiple ? translate("PlantStateSelector.placeholder.multiple", "Select States") : translate("PlantStateSelector.placeholder.single", "Select State"),
    getKey: getKey,
    renderItemText: renderItemText,
    getTagProps: function getTagProps(label, index) {
      var selected = props.selected;
      var item = selected[index];
      var backgroundColor = (0, _getPlantStateColor.getPlantStateColor)(theme, item.id);
      var style = {
        backgroundColor: backgroundColor
      };
      return {
        style: style
      };
    },
    filterable: false
  }, props));
}));